import { Logger, LoggerService } from "@Shared/logger";
import { Screen } from "./screen.base";
import { OptionsModule } from "@Modules/options_module";
import { UIModule } from "@Modules/ui_module/ui.module";
import { PipelineModule } from "@Modules/pipeline_module";
import { Bus } from "@Modules/event_module";
import { APP_EVENTS } from "@Core";
import { Auth0RegisterFormData } from "./models";
import { LoginStep } from "@Modules/pipeline_module/steps/auth/login.step";
import { RegisterStep } from "@Modules/pipeline_module/steps";
import { AuthModule } from "@Modules/auth_module";

export class RegisterScreen extends Screen {
  private Logger: Logger = LoggerService.createLogger("RegisterScreen");


  constructor() {
    super();
    this.Logger.trace("****  CTOR ****");
    this._html = UIModule.HTML.registerForm;
    this._screenOptions = OptionsModule.Options.ui.screens.register;

  }

  show(): void {
    super.show();
    if(AuthModule.AuthOptions.isTrib){
      this.handleTOSAndPPLinks();
    }
    this.Logger.trace("show called");
    this.handleForm();
    this.handlePasswordStrengthAlertClear();

    this._formSubmitHandler = this._form?.onSubmit<Auth0RegisterFormData>(async (data) => {
      this.Logger.trace("Form submitted with data:", data);

      try {
        this._alert.hide();
        const showEntitlementCheckScreen = OptionsModule.Options.entitlement.showCheckScreenOnLogin;
        const resContext = await PipelineModule.startUserInitiatedAuthPipeline(new RegisterStep(data.email, data.password), showEntitlementCheckScreen);
        this.Logger.trace("resContext", resContext);
        if (resContext.onRegister.result.success) {
          this.Logger.trace("Registration successful");
          const authMode = OptionsModule.Options.auth.mode;
          if (authMode.type === "embedded" && authMode.options.reloadOnAuth) {
            this.Logger.trace("Reloading page after registration");
            location.reload();
          } else {
            this.Logger.trace("Not Reloading Page On Registration, just firing onReady event");
            super.close();
            Bus.emit(APP_EVENTS.onReady, { auth: resContext.checkAuthStatus, entitlement: resContext?.checkEntitlements });
          }


        }

      } catch (error) {
        this.Logger.error("Login error", error);
      } finally {

      }




    });
  }

  private handlePasswordStrengthAlertClear(): void {
    const passwordInput = document.querySelector<HTMLInputElement>('#password');
    if (!passwordInput) {
      return;
    }

    passwordInput.addEventListener('input', () => {
      const message = this._alert.getMessage().toLowerCase();
      if (message.includes('password is too weak') || message.includes('passwordstrengtherror')) {
        this._alert.hide();
        this._form?.clearFieldError('password');
      }
    });
  }

  private handleTOSAndPPLinks(): void {
    const tosLink = document.querySelector('#mng-tos-link') as HTMLAnchorElement;;
    if (tosLink) {
      tosLink.href = "https://www.tribpub.com/central-terms-of-service/";
    }

    const ppLink = document.querySelector('#mng-privay-link') as HTMLAnchorElement;;
    if (ppLink) {
      ppLink.href = "https://www.tribpub.com/privacy-policy/";
    }
  }
}